import { render, staticRenderFns } from "./TempLayout.vue?vue&type=template&id=f4ec6a8e&scoped=true&lang=pug"
import script from "./TempLayout.vue?vue&type=script&lang=js"
export * from "./TempLayout.vue?vue&type=script&lang=js"
import style0 from "./TempLayout.vue?vue&type=style&index=0&id=f4ec6a8e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ec6a8e",
  null
  
)

export default component.exports